import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setElevation, setFontVariant } from "@similarweb/styles";
import { Autocomplete } from "@similarweb/ui-components";

export const AUTOCOMPLETE_ITEM_HEIGHT = 52;
export const AUTOCOMPLETE_VISIBLE_ITEM_COUNT = 4;

export const StyledListItem = styled.div<{ $isDisabled?: boolean }>`
    padding: 14px 16px;
    ${setFontVariant("input2", colorsPalettes.carbon[500])};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    cursor: ${({ $isDisabled }) => ($isDisabled ? "not-allowed" : "pointer")};
    position: relative;
    background-color: ${colorsPalettes.carbon[0]};
    min-width: 0;
    opacity: ${({ $isDisabled }) => ($isDisabled ? 0.45 : 1)};

    &:hover {
        background-color: ${({ $isDisabled }) =>
            $isDisabled ? colorsPalettes.carbon[0] : colorsPalettes.bluegrey[200]};
    }
`;

export const StyledListItemText = styled.div`
    flex: 1;
    min-width: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;

export const StyledItemsContainer = styled.div`
    max-height: ${AUTOCOMPLETE_ITEM_HEIGHT * AUTOCOMPLETE_VISIBLE_ITEM_COUNT}px;
    overflow-y: auto;
`;

export const StyledAutocomplete = styled(Autocomplete)<{ isFocused: boolean }>`
    position: relative;
    width: 100%;
    z-index: 2;

    .AutoCompleteContainer {
        transform: none;
        padding: 0;
    }

    .ListItemsContainer {
        position: absolute;
        width: 100%;
        z-index: 10;
        box-sizing: border-box;
        background-color: ${colorsPalettes.carbon[0]};
        border: 1px solid ${colorsPalettes.carbon[100]};
        ${setElevation("Z2")};

        &::before {
            display: none;
        }
    }

    > div > div {
        padding: 0;
        transform: none;
    }

    ${({ isFocused }) =>
        isFocused
            ? css`
                  & ${SWReactIcons}[data-automation-icon-name="search"] {
                      margin-top: 4px;
                      width: 24px;
                      height: 24px;
                      margin-right: 8px;
                  }
              `
            : css`
                  & ${SWReactIcons}[data-automation-icon-name="search"] {
                      display: none;
                  }
              `}
`;
